import buildEndpoint from "./buildEndpoint";

const jsonHeaders = {
  Accept: "application/json",
  "Content-Type": "application/json"
};

export default async (
  endpoint,
  { method = "GET", headers = {}, body, customFetch, ...otherParams } = {}
) => {
  const requestParams = {
    method,
    headers: {
      ...jsonHeaders,
      ...headers
    },
    ...otherParams
  };

  if (body) {
    requestParams.body = JSON.stringify(body);
  }

  const fetcher = customFetch || fetch;

  const response = await fetcher(buildEndpoint(endpoint), requestParams);

  if (response.status >= 200 && response.status < 300) {
    return response.json();
  } else {
    var error = new Error(response.statusText || response.status);
    error.response = await response.json();
    throw error;
  }
};



// WEBPACK FOOTER //
// ./src/utils/fetchJSON.js